import {Component, OnInit} from "@angular/core";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {PaymentRecordData, VenueSyncService} from "../venue-sync.service";

@Component({
    selector: "fhm-venue-sync-payments-search-page",
    styleUrls: ["venue-sync-payments-search-page.component.scss"],
    templateUrl: "./venue-sync-payments-search-page.component.html",
    providers: [VenueSyncService],
    standalone: false
})
export class VenueSyncPaymentsSearchPageComponent implements OnInit {

    gridData: PaymentRecordData[] = [];

    venueId: string;
    startDate: string = "10-05-2021";
    endDate: string = "10-11-2021";

    totalAppPayments: number;
    totalAppClips: number;

    constructor(
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private venueSyncService: VenueSyncService) {
    }

    ngOnInit(): void {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        this.endDate = this.dateToDMY(date);
        date.setMonth(date.getMonth() - 1);
        this.startDate = this.dateToDMY(date);
    }

    dateToDMY(date: Date): string {
        const d = date.getDate();
        const m = date.getMonth() + 1;
        const y = date.getFullYear();
        return (d <= 9 ? "0" + d : d) + "-" + (m <= 9 ? "0" + m : m) + "-" + y;
    }

    async load(): Promise<void> {
        this.spinnersService.open();
        try {
            this.gridData = await this.venueSyncService.getPaymentRecords(this.venueId, this.startDate, this.endDate);
            this.totalAppPayments = 0;
            this.totalAppClips = 0;
            if (this.gridData && this.gridData.length > 0) {
                this.totalAppPayments = this.gridData.map(value => value.appPayments).reduce((previousValue, currentValue) => previousValue + currentValue);
                this.totalAppClips = this.gridData.map(value => value.appClips).reduce((previousValue, currentValue) => previousValue + currentValue);

                this.totalAppPayments = Math.floor(this.totalAppPayments * 100) / 100;
                this.totalAppClips = Math.floor(this.totalAppClips * 100) / 100;
            }
        } catch (error) {
            this.errorHandler.handleErrorResponse(error);
        } finally {
            this.spinnersService.close();
        }
    }

    valueColumnFn(columnName: string, record: any): any {
        if (columnName === "date") {
            return record.date.substring(6, 8) + "/" + record.date.substring(4, 6) + "/" + record.date.substring(0, 4);
        }
        return record[columnName];
    }
}
